export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";